import { CSSProperties, ReactNode, createElement, useRef } from 'react';

type StickyProps = {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
    zIndex?: number;
    inline?: boolean;
    tag?: string;
    children?: ReactNode;
    id?: string;
    className?: string;
};

const Sticky = ({
    children,
    top,
    right,
    bottom,
    left,
    inline,
    zIndex,
    id,
    className,
    tag = 'div',
}: StickyProps) => {
    const ref = useRef<HTMLDivElement>(null);

    const style: CSSProperties = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        position: 'sticky',
        display: inline ? 'inline-block' : 'block',
        zIndex: zIndex,
    };

    return createElement(tag, { style, id, className, ref }, children);
};

export default Sticky;
